<template>
  <div>
    <Assesment
      :addAssesment="addAssesment"
      @close-addAssesment="toggleaddAssesment"
      :chapter="chapter_id"
    />
    <LiveEvent
      :addLiveEvent="addLiveEvent"
      @close-addLiveEvent="toggleaddLiveEvent"
      :chapter="chapter_id"
    />
    <Embedded
      :addEmbed="addEmbed"
      @close-addEmbed="toggleaddEmbed"
      :chapter="chapter_id"
    />
    <modal
      :show.sync="AddTopic"
      scrollable
      header-classes="bg-primary p-2 flex items-center"
      footerClasses=""
      size="lg"
      bodyClasses=""
      @close="closeModal"
    >
      <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
        Add Topic
      </h6>
      <div>
        <div class="mb-6">
          <p class="font-semibold text-md pb-1">Topic Name</p>
          <base-input
            placeholder="Enter Topic Name"
            class="cust-mb0"
            name="topic"
            :rules="{ required: true }"
            v-model="name"
          ></base-input>
        </div>
        <div class="mb-4">
          <p class="font-semibold text-md pb-1">Upload Files</p>
          <div class="flex">
            <!-- <vx-card
              class="shadow-none  bg-f4f5f6 mx-1 hover:bg-white cursor-pointer py-3 rounded-lg"
              v-for="(item,index) in chapters" :key="index"
            > -->
            <!-- <vx-card
              class="
                shadow-none
                mx-auto
                cursor-pointer
                py-3
                hover:bg-white
                bg-f4f5f6
                rounded-lg
                w-full
              "
            > -->
            <!-- <div @click="inpt()">
                  <div class="flex justify-center ">
                    <img :src="item.img" class="w-2/5" />
                  </div>
                  
                  <p class="font-semibold text-center text-sm pt-2" >
                    {{item.title}}
                    <input type="file" style="display : none" class="inpts">
                  </p>
              </div> -->
            <div class="grid grid-cols-4 gap-4 w-full">
              <vx-card
                class="shadow-none cursor-pointer py-3 hover:bg-white border-2 hover:border-primary bg-f4f5f6 rounded-lg"
              >
                <div @click="vidInput(docVideo)" id="vidDisable" class="">
                  <div class="flex justify-center">
                    <img src="../img/video.png" class="w-1/4" />
                  </div>

                  <p class="font-semibold text-center text-sm pt-2">
                    Video
                    <!-- previous video accept: accept=".mkv,.avi,video/*" -->
                    <input
                      type="file"
                      style="display: none"
                      ref="vidfile"
                      id="videoInput"
                      accept=".mp4,.mkv,.avi,video/*"
                      class="videoInput"
                      @change="onFileChange"
                    />
                  </p>
                </div>
              </vx-card>
              <vx-card
                class="shadow-none cursor-pointer py-3 hover:bg-white border-2 hover:border-primary bg-f4f5f6 rounded-lg"
              >
                <div @click="docsInput(docPdf)" id="docDisable">
                  <div class="flex justify-center">
                    <img src="../img/doc.png" class="w-1/4" />
                  </div>
                  <p class="font-semibold text-center text-sm pt-2">
                    Documents
                    <!-- previous doc accept: accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" -->
                    <input
                      type="file"
                      style="display: none"
                      ref="docfile"
                      accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      id="docInput"
                      @change="onFileChange"
                    />
                  </p>
                  <p class="text-xs text-center text-muted mt-1 px-2">
                    PDF, DOC, DOCX allowed
                  </p>
                </div>
              </vx-card>
              <vx-card
                class="shadow-none cursor-pointer py-3 hover:bg-white border-2 hover:border-primary bg-f4f5f6 rounded-lg"
              >
                <div>
                  <div
                    class="flex justify-center"
                    @click="embedded(chapter_id)"
                  >
                    <img src="../img/embed.png" class="w-1/4" />
                  </div>
                  <p class="font-semibold text-center text-sm pt-2">Embedded</p>
                </div>
              </vx-card>
              <vx-card
                class="shadow-none cursor-pointer py-3 hover:bg-white border-2 hover:border-primary bg-f4f5f6 rounded-lg"
              >
                <div>
                  <div
                    class="flex justify-center"
                    @click="assesment(chapter_id)"
                  >
                    <img src="../img/assessment.png" class="w-1/4" />
                  </div>
                  <p class="font-semibold text-center text-sm pt-2">
                    Assessment
                  </p>
                </div>
              </vx-card>
              <vx-card
                class="shadow-none cursor-pointer py-3 hover:bg-white border-2 hover:border-primary bg-f4f5f6 rounded-lg"
              >
                <div>
                  <div
                    class="flex justify-center"
                    @click="liveevent(chapter_id)"
                  >
                    <img src="../img/live.png" class="w-1/4" />
                  </div>
                  <p class="font-semibold text-center text-sm pt-2">
                    Live Event
                  </p>
                </div>
              </vx-card>
            </div>

            <!-- </vx-card> -->
          </div>
        </div>
        <div class="mb-6">
          <div class="progress-wrapper">
            <div class="progress rounded-lg mb-0">
              <div
                class="progress-bar bg-default"
                role="progressbar"
                :aria-valuenow="progressPercentage"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="{ width: progressPercentage + '%' }"
              ></div>
            </div>
            <div class="progress-info pt-1 mb-0">
              <div class="progress-label">
                <span class="badge badge-pill badge-default">In Progress</span>
              </div>
              <div class="progress-percentage">
                <span class="">{{ progressPercentage }}%</span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-center" v-if="files && files.length !== 0">
          <div class="flex px-5 py-1 bg-f4f5f6 rounded-full">
            <p
              class="text-xs font-semibold"
              v-for="(file, index) in files"
              :key="index"
            >
              {{ file.name }}
            </p>
            <feather-icon
              icon="XIcon"
              class="font-semibold cursor-pointer icon18px ml-5 my-auto"
              @click="removeImage()"
            ></feather-icon>
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button type="primary" @click="createTopic()"
          >ADD TOPIC</base-button
        >
        <base-button @click="closeModal" type="secondary" class="ml-auto"
          >CLOSE</base-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Assesment from "./Assesment.vue";
import Embedded from "./addEmbedded.vue";
import LiveEvent from "./addliveevent.vue";
import {
  isAllowedDocumentFile,
  isAllowedVideoFile,
} from "@/utils/mediaUrl";
export default {
  components: {
    Assesment,
    Embedded,
    LiveEvent,
  },
  props: {
    AddTopic: Boolean,
    chapter_id: Object,
  },
  data() {
    return {
      // chapters: [
      //   {
      //     img: require("../img/video.png"),
      //     title: "Video"
      //   },
      //   {
      //     img: require("../img/doc.png"),
      //     title: "Document"
      //   },
      //   {
      //     img: require("../img/embed.png"),
      //     title: "Embedded"
      //   },
      //   {
      //     img: require("../img/assessment.png"),
      //     title: "Assessment"
      //   },
      //   {
      //     img: require("../img/live.png"),
      //     title: "Live Event"
      //   }
      // ],
      addAssesment: false,
      addEmbed: false,
      addLiveEvent: false,

      name: "",
      files: [],

      fileName: null,
      docVideo: "video",
      docPdf: "pdf",
      vidDuration: "10",

      // maxSize: 1,
      maxSize: 20 * 1024 * 1024,
    };
  },
  methods: {
    // getVideoDuration(file) {
    //   new Promise((resolve, reject) => {
    //     const reader = new FileReader();
    //     reader.onload = () => {
    //       const media = new Audio(reader.result);
    //       media.onloadedmetadata = () => {
    //         console.log(media.duration);
    //         resolve(media.duration);
    //       };
    //     };
    //     reader.readAsDataURL(file);
    //     reader.onerror = (error) => reject(error);
    //   });
    // },
    vidInput(data) {
      document.getElementById("vidDisable").style.pointerEvents = "auto";
      document.getElementById("docDisable").style.pointerEvents = "none";
      let input = document.getElementById("videoInput").click();

      // console.log(data);
    },
    // validation(){
    // let filename = document.getElementsByClassName("videoInput").value;
    // console.log(filename);
    // let ext = filename.substring(filename.lastIndexOf('.') + 1);
    // alert(ext);

    docsInput(data) {
      document.getElementById("vidDisable").style.pointerEvents = "none";
      document.getElementById("docDisable").style.pointerEvents = "auto";
      document.getElementById("docInput").click();
      // console.log(data);
    },
    // embInput(){
    //   document.getElementById("embedInput").click();
    // },
    // assesInput(){
    //   document.getElementById("assesInput").click();

    // },
    // liveInput(){
    //   document.getElementById("liveInput").click();

    // },
    async onFileChange(e) {
      this.files = e.target.files;
      let self = this;
      // console.log(this.$refs.vidfile.files[0], "787987");
      if (this.$refs.vidfile.files[0]) {
        const videoFile = this.$refs.vidfile.files[0];
        // Previous video validation:
        // if (!this.$refs.vidfile.files[0].type.includes("video")) {
        //   this.$swal.fire({
        //     title: "Error",
        //     text: "Please Select Video File",
        //     icon: "warning",
        //     showConfirmButton: false,
        //     showCancelButton: false,
        //     timer: 2000,
        //   });
        //   this.removeImage();
        // }
        if (!isAllowedVideoFile(videoFile)) {
          this.$swal.fire({
            title: "Error",
            text: "Only MP4, MKV, and AVI video files are allowed",
            icon: "warning",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
          this.removeImage();
          return;
        }
        if (videoFile.size > this.maxSize) {
          this.$swal.fire({
            title: "Error",
            text: "File size exceeds 20MB!",
            icon: "warning",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
          this.removeImage();
        }
        let vid = document.createElement("video");
        let fileUrl = URL.createObjectURL(this.$refs.vidfile.files[0]);
        vid.src = fileUrl;

        vid.ondurationchange = function () {
          let duration = Number(this.duration).toFixed(0);
          self.vidDuration = duration;
        };
        // try {
        //   this.vidDuration = this.getVideoDuration(e.target.files[0]);
        //   console.log(this.vidDuration);
        // } catch (error) {
        //   console.log(error);
        // }
        this.fileName = this.$refs.vidfile.files[0].name;
      } else if (this.$refs.docfile.files[0]) {
        const docFile = this.$refs.docfile.files[0];
        // Previous document validation (was disabled):
        // if (!this.$refs.docfile.files[0].type.includes("application")) {
        //   this.$swal.fire({
        //     title: "Error",
        //     text: "Please Select Proper Document File",
        //     icon: "warning",
        //     showConfirmButton: false,
        //     showCancelButton: false,
        //     timer: 2000,
        //   });
        //   this.removeImage();
        // }
        if (!isAllowedDocumentFile(docFile)) {
          this.$swal.fire({
            title: "Error",
            text: "Only PDF, DOC, and DOCX files are allowed",
            icon: "warning",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
          this.removeImage();
          return;
        }
        if (docFile.size > this.maxSize) {
          this.$swal.fire({
            title: "Error",
            text: "File size exceeds 20MB!",
            icon: "warning",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
          this.removeImage();
        }
        this.fileName = this.$refs.docfile.files[0].name;
      }

      // console.log(this.vidDuration);
      // console.log(this.fileName);
      // console.log(this.vidDuration);
    },

    removeImage() {
      document.getElementById("videoInput").value = "";
      document.getElementById("docInput").value = "";
      document.getElementById("vidDisable").style.pointerEvents = "auto";
      document.getElementById("docDisable").style.pointerEvents = "auto";
      this.files = "";
    },

    async createTopic() {
      // console.log(this.vidDuration);
      let payload = new FormData();
      payload.append("name", this.name);
      payload.append("chapter", this.chapter_id._id);
      payload.append("course", this.chapter_id.course);
      const filename = this.fileName;
      const ext = filename.split(".").pop();
      // console.log(ext);

      if (ext == "mp4" || ext == "mkv" || ext == "avi") {
        payload.append("docType", "video");
        payload.append("duration", this.vidDuration);
        payload.append("docPath", this.$refs.vidfile.files[0]);
      } else if (ext == "doc" || ext == "docx" || ext == "pdf") {
        payload.append("docType", ext.toLowerCase());
        payload.append("duration", "");
        payload.append("docPath", this.$refs.docfile.files[0]);
      }
      // let formObj = {};
      // for (var pair of payload.entries()) {
      //   formObj[pair[0]] = pair[1];
      // }
      // console.log(formObj);
      let loader = this.$loading();
      try {
        const data = await this.$store.dispatch(
          "eLearning/createTopic",
          payload
        );
        if (data.code == 200) {
          loader.close();

          this.$swal.fire({
            title: "Created",

            text: "Topic has been created Successfully!",

            icon: "success",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
          this.name = "";
          this.removeImage();
          this.closeModal();
        }
      } catch (err) {
        loader.close();
        if (err.response.data.message.includes("duplicate key error")) {
          this.$swal.fire({
            title: "Error",

            text: "Topic Name Already Exists!",

            icon: "warning",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
        }
      }
    },
    closeModal() {
      this.$emit("close-addTopic");
    },
    assesment(data) {
      this.toggleaddAssesment(true);
    },
    async toggleaddAssesment(val = false) {
      this.addAssesment = val;
      if (val == false) {
        this.name = "";
        this.closeModal();
      }
    },
    embedded(data) {
      this.toggleaddEmbed(true);
    },
    async toggleaddEmbed(val = false) {
      this.addEmbed = val;
      if (val == false) {
        this.name = "";
        this.closeModal();
      }
    },
    liveevent(data) {
      this.toggleaddLiveEvent(true);
    },
    async toggleaddLiveEvent(val = false) {
      this.addLiveEvent = val;
      if (val == false) {
        this.name = "";
        this.closeModal();
      }
    },
  },
  computed: {
    ...mapState("eLearning", ["videoDuration"]),
    ...mapState("eLearning", ["progressPercentage"]),
  },
};
</script>
